























































import { Component, Vue } from 'vue-property-decorator';

import AnalyticsCardList, {
  AnalyticsCardListItem
} from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';
import AnalyticsCard from '@/componentsV2/molecules/AnalyticsCard/AnalyticsCard.vue';
import SectionWrapper from '@/componentsV2/molecules/SectionWrapper/SectionWrapper.vue';
import CampaignSummary, {
  CampaignSummaryListItem
} from '@/componentsV2/molecules/CampaignSummary/CampaignSummary.vue';
import CampaignStatistics from '@/componentsV2/molecules/CampaignStatistics/CampaignStatistics.vue';

import CustomerImportService from '@/api/CustomerImportService';

import eventBus from '@/utils/eventBus';

import { ICampaignStatistics } from '@/models/customer-import';

import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    SectionWrapper,
    AnalyticsCardList,
    CampaignSummary,
    CampaignStatistics,
    AnalyticsCard
  }
})
export default class CustomerImportOverview extends Vue {
  customerImportService = new CustomerImportService();

  campaignSummaryFooterText: string = '';
  campaignSummaryTooltipText: string = '';

  importedOverview: Record<string, AnalyticsCardListItem> = {
    importedCustomers: {
      variant: 'white',
      infos: {
        title: 'Imported customers',
        amount: 0,
        tooltipText: '',
        counterFractionDigits: 0,
        disableAbbreviateAmount: true
      }
    },
    loyaltyProgramCustomers: {
      variant: 'white',
      infos: {
        title: 'Reward program customers',
        amount: 0,
        tooltipText: '',
        counterFractionDigits: 0,
        disableAbbreviateAmount: true
      }
    },
    enrollmentRate: {
      variant: 'white',
      infos: {
        title: 'Enrollment rate',
        amount: 0,
        tooltipText: '',
        disableAbbreviateAmount: true,
        sufixAmount: '%'
      }
    }
  };

  importedCampaignSummary: Record<string, CampaignSummaryListItem> = {
    totalRedeemedCoins: {
      label: 'Total Coins Claimed',
      amount: 0
    },
    convertedCustomers: {
      label: 'Converted Customers',
      amount: 0
    },
    convertionRate: {
      label: 'Converted Rate',
      amount: 0,
      sufixAmount: '%'
    }
  };

  campaignStatisticsList: AnalyticsCardListItem[] = [];
  campaignCreatedAt: null | string = null;

  minWidthCardMobile = 0;

  get tPrefix() {
    return 'customerImport';
  }

  get currentProvider() {
    return this.$store.getters[
      'merchant/getConnectedProviderWithWidgetSettings'
    ];
  }

  get translatedImportedOverview() {
    return Object.entries(this.importedOverview)
      .map(([key, value]) => ({
        ...value,
        infos: {
          ...value.infos,
          tooltipText: this.$t(`${this.tPrefix}.overview.${key}.tooltip`),
          title: this.$t(`${this.tPrefix}.overview.${key}.title`)
        }
      }))
      .filter(({ hidden }) => !hidden);
  }

  mounted() {
    this.reloadCustomerImportOverview();
    eventBus.$on(
      'reloadCustomerImportOverview',
      this.reloadCustomerImportOverview
    );
  }

  beforeDestroy() {
    eventBus.$off(
      'reloadCustomerImportOverview',
      this.reloadCustomerImportOverview
    );
  }

  async reloadCustomerImportOverview() {
    await this.getOverview();
    await this.getCustomerImportSummaryAndStatistics();
    if (!this.$mobileCheck()) return;
    const element = document.querySelector(
      '.customer-import-overview__row'
    ) as HTMLDivElement;
    const { children } = element;
    let biggerWidth = 0;

    for (let i = 0; i < children.length; i++) {
      const element = children[i] as HTMLDivElement;
      if (element.offsetWidth > biggerWidth) biggerWidth = element.offsetWidth;
    }
    this.minWidthCardMobile = biggerWidth;
  }

  async getOverview() {
    this.$showLoaderWithLocker();

    const response = await this.customerImportService.getOverview(
      this.currentProvider.name
    );

    this.$hideLoader();

    if (response.status !== 200) return;

    const {
      importedCustomers,
      loyaltyProgramCustomers,
      enrollmentRate
    } = response.data;

    this.importedOverview.importedCustomers.infos.amount = importedCustomers;
    this.importedOverview.loyaltyProgramCustomers.infos.amount = loyaltyProgramCustomers;

    this.importedOverview.enrollmentRate.infos.amount = parseFloat(
      enrollmentRate
    );
  }

  async getCustomerImportSummaryAndStatistics() {
    this.$showLoaderWithLocker();

    const response = await this.customerImportService.getCustomerImportSummaryAndStatistics(
      this.currentProvider.name
    );

    this.$hideLoader();

    if (response.status !== 200) return;

    const { statistics, summary, campaignCreatedAt } = response.data;

    this.campaignCreatedAt = campaignCreatedAt;

    const {
      totalRedeemedCoins,
      convertedCustomers,
      convertionRate,
      coinsPerCustomer
    } = summary;

    this.importedCampaignSummary.totalRedeemedCoins.amount = parseFloat(
      totalRedeemedCoins
    );
    this.importedCampaignSummary.convertedCustomers.amount = parseFloat(
      convertedCustomers
    );
    this.importedCampaignSummary.convertionRate.amount = parseFloat(
      convertionRate
    );

    this.campaignSummaryFooterText = `${parseFloat(
      coinsPerCustomer
    )} ${this.$tc(
      `common.pluralize.coin`,
      Number(coinsPerCustomer) || 1
    )} per customer`;
    this.campaignSummaryTooltipText = String(
      this.$t(`${this.tPrefix}.campaignSummary.tooltip`)
    );

    this.campaignStatisticsList = [];

    const infos = statistics.map((item: ICampaignStatistics) => {
      const valueHasPercentage = item.value.includes('%');

      return {
        infos: {
          amount: parseFloat(item.value),
          description: item.label,
          tooltipText: item.tooltip,
          disableAbbreviateAmount: true,
          ...(valueHasPercentage && { sufixAmount: '%' })
        }
      };
    });

    this.campaignStatisticsList = infos;
  }
}
